import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';
import { DopMenuService } from 'projects/dop-menu/src/lib/dop-menu.service';
import { AuthConfigService } from './auth-config.service';

@Injectable()
export class DopAuthService {

  private authConfig: AuthConfig;

  constructor(
    private authConfigService: AuthConfigService,
    private oauthService: OAuthService,
    private dopMenuService: DopMenuService,
    private httpClient: HttpClient) {
  }


  async login(configurationPath: string, internalFileName: string) {
    await this.setConfiguration(configurationPath);
    if (internalFileName !== '') {
      window.localStorage.setItem('internalFileName', internalFileName);
    } else if (!window.location.hash.includes('access_token') && window.localStorage.getItem('internalFileName') != null) {
      window.localStorage.removeItem('internalFileName');
    }
    await this.oauthService.tryLogin()
      .then(async () => {
        this.dopMenuService.setupSessionValidator();
        if (!this.oauthService.hasValidAccessToken()) {
          this.oauthService.initImplicitFlow();
        }
        else
        {
          const sessionId = this.getSessionId();
          if (sessionId !== null) {
            const queryApiBaseUrl = this.authConfigService.fullConfigurations?.apiConfig.orderQueryBaseUrl;
            const url = queryApiBaseUrl + 'authentication/session/' + sessionId + '/status';
            this.httpClient.get(url).subscribe((data: any) => {
                if(data !== null && data.isRevoked) {
                    this.oauthService.logOut();
                    window.location.reload();
                }
                else {
                  return true;
                }
            });
          }
        }
        return true;
      });
  }

  private getSessionId(): string {
    const idClaims = this.oauthService.getIdentityClaims();
    type ObjectKey = keyof typeof idClaims;
    if (idClaims === null || idClaims === undefined) {
        return null;
    }
    return idClaims['pi.sri' as ObjectKey];
  }

  private async setConfiguration(configurationPath: string) {
    await this.authConfigService.setConfiguration(configurationPath);
    this.authConfig = this.authConfigService.setupAuthConfig();
    this.oauthService.configure(this.authConfig);
  }

  get postLogoutRedirectUrl() {
    return this.oauthService.postLogoutRedirectUri;
  }

  get redirectUrl(): string {
    return this.oauthService.redirectUri;
  }

  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }

  get idToken(): string {
    return this.oauthService.getIdToken();
  }

  get claims() {
    return this.oauthService.getIdentityClaims();
  }

  get isLoggedIn() {
    return this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken();
 }

  logout() {
    this.oauthService.logOut();
  }

}
